<template>
<div>
      <section>
        <v-parallax class="my-0" :src="items[0].src" height="600">
          <v-layout column align-center justify-center class="white--text">
            <h1 class="white--text mb-2 display-1 text-center" style="font-weight: 900; text-shadow: 3px 2px #000000">The Powerpoint of Market Analytics</h1>
            <div class="white--text subheading mb-3 text-center" style="font-weight: 900; text-shadow: 2px 2px #000000">Unlesh your creativity without limitations</div>
            <registerDark />
          </v-layout>
        </v-parallax>
      </section>
      <section>
        <v-layout
          column
          wrap
          class="my-0"
          align-center
        >
          <v-flex xs12 sm4 center class="my-0">
            <div class="text-center">
              <h2 class="headline">From idea generation to idea execution</h2>
              <span class="subheading">
                No more restrictions, no more limits
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2">fas fa-bolt</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Cloud first</div>
                    </v-card-title>
                    <v-card-text>
                    Market data aggerated and filtered at your fingertips. There when you need it the most. Users actions and access are audited and monitored by default. Your data's security is our number one priority.                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2">far fa-handshake</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Fast feedback</div>
                    </v-card-title>
                    <v-card-text>
                    Time is essential, we don't want you to waste it. The algorithms you design with Pivot3 are optimized to run on the right sized environment. Our dynamic engine allows you to focus on the research without worrying about cost or time spent.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-center">
                      <v-icon x-large class="blue--text text--lighten-2">far fa-lightbulb</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Create and connect</div>
                    </v-card-title>
                    <v-card-text>
                    Complex algorithms are easy to create, share, and execute using Pivot3's online editor and cloud engine. Collaborating on market research has never been so easy. Every algorithm developed is a building block for next!
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

            <section>
        <v-parallax :src="items[3].src" height="380">
          <v-layout column align-center justify-center>
            <div class="headline white--text mb-3 text-center">Pivot3 is an end-to-end solution that allows anyone to gain and share market insights.</div>
            <em>With the power of Pivot3 you don't need to be a quant in order to execute on your ideas</em>
              <router-link to="/">
            <v-btn class="blue lighten-2 mt-5" dark large target="_blank">
              Get more info
            </v-btn>
                          </router-link>
          </v-layout>
        </v-parallax>
      </section>
<section>
        <v-container grid-list-md>

        
          <v-layout row >
          <v-flex xs12 text-center class="mt-5">
           <div class="headline">Are you amazed? Stay tuned!</div>
           <br>
          <div>We are launching the beta soon. If you want to be one of the first Pivot3 users, we will email you as soon as we're ready. Let us know how Pivot3 will help you!</div>
          </v-flex>

            </v-layout>
        <v-flex xs12 text-center class="mt-5">
  <register/>
 </v-flex>
          </v-container>
      </section>         
  </div >
</template>

<script>
import register from "../components/Register"
import registerDark from "../components/RegisterDark"
import bigData from "../assets/bigData.jpg"
import bigData2 from "../assets/bigData2.jpg"
export default {
    components:{
      register,
      registerDark
    },
    data () {
      return {
        icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-google-plus',
        'fab fa-linkedin',
        'fab fa-instagram',
      ],
        items: [
          {
            src: bigData2,
          },
             {
            src: bigData,
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
          },
        ],
      }
    },
      computed: {
    imgHeight: function() {
      var offset = 320;
      console.log("new image height is " + (this.pageHeight - offset));
      return this.pageHeight - offset;
    }
  },

  mounted: function() {

  }
  }
</script>